var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLife(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66665C11.6583 6.66665 12.5 7.50831 12.5 9.16665C12.5 10.825 11.6583 11.6666 10 11.6666C8.34167 11.6666 7.5 10.825 7.5 9.16665C7.5 7.50831 8.34084 6.66665 10 6.66665ZM9.39584 5.65998C9.7625 5.89081 10.2375 5.89081 10.6042 5.65998C11.4583 5.12248 12.9167 3.91581 12.9167 2.30581C12.9167 1.49248 12.2633 0.833313 11.4583 0.833313C10.6533 0.833313 10 1.38331 10 2.19665C10 1.38331 9.34667 0.833313 8.54167 0.833313C7.73667 0.833313 7.08334 1.49248 7.08334 2.30581C7.08334 3.91581 8.54167 5.12248 9.39584 5.65998ZM18.4892 7.63915C17.8767 7.32331 17.1225 7.56331 16.805 8.17748C15.2917 11.0425 12.2658 12.4033 12.0242 12.6341C11.4342 12.5666 10.685 12.5008 9.99917 12.5008C9.31334 12.5008 8.56334 12.5666 7.97334 12.6341C7.71334 12.4025 4.73334 11.0491 3.19334 8.17748C2.8775 7.56415 2.12334 7.32415 1.50917 7.63915C0.895836 7.95581 0.655002 8.70915 0.970835 9.32331C2.34417 11.9858 4.93834 13.7375 6.06917 14.4083C5.96084 15.2066 5.83167 16.3891 5.83167 17.5316C5.83167 17.6766 5.83417 18.2166 5.83834 18.3575C5.85167 18.8083 6.22084 19.1666 6.67167 19.1666H13.3267C13.7792 19.1666 14.1483 18.805 14.16 18.3525C14.1633 18.2125 14.1658 17.6758 14.1658 17.5316C14.1658 16.3883 14.0367 15.2066 13.9283 14.4083C15.0592 13.7375 17.6533 11.985 19.0267 9.32331C19.3433 8.70998 19.1033 7.95581 18.4892 7.63915Z",
    fill: "url(#paint0_linear_192_455)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_455",
    x1: 9.99902,
    y1: 0.833313,
    x2: 9.99902,
    y2: 19.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLife);
export default __webpack_public_path__ + "static/media/life.76bb72cc230813a4e5dcaab12eec9329.svg";
export { ForwardRef as ReactComponent };